export default __webpack_public_path__ + "static/media/foie.050ea124.jpg";